import { request } from '../utils';
import { alert } from '../components';

function _shopNum(root, data, skuItems, callback: any) {
    let num = data.num;
    if (root == 'jia') {
        num++;
    } else if (root == 'jian') {
        num--;
    }
    request('newproduct/carts/v1/update', {
        num: num,
        skuId: skuItems.skuId
    }).then((rd) => {
        if (rd.errCode == '204' || rd.errCode == '200') {
            callback(true);
        } else {
            alert(rd.errDesc, ['知道了']);
            callback(false);
        }
    });
}

export default _shopNum;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/operates/shopnum.ts